import { OptimizelyProvider, useDecision } from '@optimizely/react-sdk';
import { ONETRUST_OPTOUT_LOGGED_IN_FLAG } from '@fff-web/consent/data-subject';
import { LegalItem } from '../../services/types';
import { getOptimizely } from '../../utils/optimizely';
import { useOptimizelyUser } from '../../utils/useOptimizelyUser';
import { LegalFooter } from './LegalFooter';
import { isOptOutState, useGeoState } from './useGeoState';

interface Props {
  legals: LegalItem[];
  isLoggedIn: boolean;
}

const LegalFooterWithFlag = ({ legals }: Pick<Props, 'legals'>) => {
  const [decision] = useDecision(ONETRUST_OPTOUT_LOGGED_IN_FLAG);

  return (
    <LegalFooter
      legals={legals}
      isLoggedIn
      showOptOutWhenLoggedIn={decision.variationKey === 'on'}
    />
  );
};

const LegalFooterContainer = ({ legals, isLoggedIn }: Props) => {
  const user = useOptimizelyUser();
  const geoState = useGeoState();

  if (!isLoggedIn || !isOptOutState(geoState)) {
    return <LegalFooter legals={legals} isLoggedIn={isLoggedIn} />;
  }

  return (
    <OptimizelyProvider optimizely={getOptimizely()} user={user}>
      <LegalFooterWithFlag legals={legals} />
    </OptimizelyProvider>
  );
};

export { LegalFooterContainer };
